import React from 'react';
import Lottie from 'lottie-react-web';
import LottieAnim from '../../Assets/nodata.json';

export function NodataLottie({...rest}) {
	const defaultLottieOptions = {
		loop: true,
		autoplay: true,
		animationData: LottieAnim,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice'
		}
	};

	return (
		<Lottie
			options={defaultLottieOptions}
			forceSegment={true}
			width={rest?.width || '25%'}
			height={rest?.height || '25%'}
		/>
	)
}
